import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function BlogCard({ blog, index = 0 }) {
  const [imageError, setImageError] = useState(false);

  const truncateDescription = (text, maxLength = 120) => {
    if (!text) return 'No description available';
    return text.length <= maxLength ? text : text.substring(0, maxLength).trim() + '...';
  };

  return (
    <div
      className="col-12 col-md-6 col-xl-4"
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      <article className="card blogs-card border-0">
        <Link to={`/blogs/${blog.slug}`} className="blogs-card-media">
          {blog.featuredImage && !imageError ? (
            <img
              loading="lazy"
              decoding="async"
              src={blog.featuredImage}
              alt={blog.title}
              className="blogs-card-image"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="blogs-card-fallback">No Image</div>
          )}
        </Link>

        <div className="blogs-card-divider" />

        <div className="card-body blogs-card-body d-flex flex-column">
          <div className="blogs-card-meta ff_n">
            <span>{blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : 'No date'}</span>
            {blog.readTime && <span>{blog.readTime} min read</span>}
          </div>

          <h2 className="blogs-card-title ff_s">{blog.title || 'Untitled'}</h2>

          <p className="blogs-card-text ff_n">
            {truncateDescription(blog.description)}
          </p>

          <Link to={`/blogs/${blog.slug}`} className="blogs-card-link ff_n">
            Read More
          </Link>
        </div>
      </article>
    </div>
  );
}
